export { default as HeadingComponent } from './HeadingComponent'
export type { DetailInfo } from './HeadingComponent'
export { default as headingComponentFactory } from './HeadingComponentFactory'
